export default "__VITE_ASSET__6yjDd5Ow__"